import React from "react";

import "./ProjectHero.scss";

interface ProjectHeroProps {
  title: string;
  subtitle: string;
  category?: string;
  role?: string;
  timeline?: string;
  year?: string;
  platform?: string;
  client?: string;
  technologies?: string[];
}

export function ProjectHero({
  title,
  subtitle,
  category,
  role,
  timeline,
  year,
  platform,
  client,
  technologies,
}: ProjectHeroProps) {
  return (
    <section className="projectHero">
      {/* Hero Content */}
      <div className="heroContent">
        <div className="heroText">
          <div className="heroCategory">
            <span>{category}</span>
          </div>
          <h1 className="heroTitle">{title}</h1>
          <p className="heroSubtitle">{subtitle}</p>
        </div>
        {/* Project Meta */}
        <div className="heroMeta">
          <div className="metaItem">
            <div className="metaLabel">Client</div>
            <div className="metaValue">{client}</div>
          </div>
          <div className="metaItem">
            <div className="metaLabel">Role</div>
            <div className="metaValue">{role}</div>
          </div>

          <div className="metaItem">
            <div className="metaLabel">Year</div>
            <div className="metaValue">{year}</div>
          </div>

          <div className="metaItem">
            <div className="metaLabel">Platform</div>
            <div className="metaValue">{platform}</div>
          </div>

          <div className="metaItem">
            <div className="metaLabel">Technologies</div>
            <div className="metaValue">{technologies?.toString()}</div>
          </div>
        </div>
      </div>
    </section>
  );
}
